import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

import {
  // Home as HomeIcon,
  // Map as MapIcon,
  PinDrop as POIIcon,
  BorderAll as GeoFenceIcon,
  // Warning as SegnalazioniIcon,
  // SmsFailed as RichiesteIcon,
  // Build as InterventiIcon,
  // MeetingRoom as EvacuazioneIcon,
  // AccountBalance as CompagniaIcon,
  // Domain as ComplessoIcon,
  // Phonelink as DispositiviIcon,
  // Group as UtentiIcon,
} from "@material-ui/icons";

const useStyles = makeStyles({
  root: {},
  title: {
    padding: 20,
    borderBottom: "1px solid #D8D8D8",
  },
  notificationBox: {
    width: "100%",
    borderBottom: "1px solid #D8D8D8",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#E4F2F7",
    },
  },
  notification: {
    padding: "30px",
  },
  icon: {
    "& svg": {
      color: "#98B1B9",
      maxWidth: 30,
      height: 30,
    },
  },
  textBox: {
    padding: "0 30px",
  },
});

const notifications = [
  {/* 
      {
        icon: <POIIcon></POIIcon>,
        titolo: "Titolo",
        descrizione: "Descrizione della notifica ricevuta",
        tempo: "25 min",
      },
      {
        icon: <GeoFenceIcon></GeoFenceIcon>,
        titolo: "Altra Notifica",
        descrizione: "Test del testo di notifica",
        tempo: "25 min",
      },
  */} 
];

export default function NotificationsRightPanel(props) {
  const classes = useStyles();
  return (
    <Grid container className={classes.root}>
      <Grid
        container
        className={classes.title}
        alignItems="center"
        justify="space-between"
      >
        <IconButton
          color="inherit"
          aria-label="close"
          onClick={props.toggleDrawer("notifications", false)}
        >
          <ChevronRightIcon />
        </IconButton>
        <Typography variant="h2">Centro Notifiche</Typography>
      </Grid>
      {notifications.map((notification) => {
        return (
          <Grid container className={classes.notificationBox}>
            <Grid
              container
              item
              className={classes.notification}
              alignItems="center"
            >
              <Grid
                container
                item
                xs={1}
                className={classes.icon}
                alignItems="center"
                justify="center"
              >
                {notification.icon}
              </Grid>
              <Grid
                container
                item
                xs={8}
                className={classes.textBox}
                direction="column"
              >
                <Typography variant="subtitle1">
                  {notification.titolo}
                </Typography>
                <Typography variant="body2">
                  {notification.descrizione}
                </Typography>
              </Grid>
              <Grid
                container
                item
                xs={3}
                className={classes.timeBox}
                justify="flex-end"
              >
                <Typography variant="caption">{notification.tempo}</Typography>
              </Grid>
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
}
